import React, { Component } from 'react';
import { NewLayout } from './components/NewLayout';
import CookieConsent from 'react-cookie-consent'
import './custom.css'
import { Receipt } from '../src/components/Receipt';
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";

export default class App extends Component {
  static displayName = App.name;

  render () {
      return (
          <div>

              <Router>
                  <Switch>
                      <Route path={"/Receipt"} component={Receipt} ></Route>

                      <Route path={"/"} >
                          <NewLayout />
                          <CookieConsent
                              style={{ background: "#292526" }}
                              buttonStyle={{ background: "#44b3ac", color: "#292526", fontSize: "1rem", borderRadius: "16px" }}
                              enableDeclineButton
                              declineButtonStyle={{ background: "#44b3ac", color: "#292526", fontSize: "1rem", borderRadius: "16px" }}
                              declineButtonText="Reject"
                              buttonText="Accept">
                              We are using cookies to give you the best experience on our website.
                              To find out more, read our <a href="https://www.pierse.ie/privacy-policy">privacy policy</a> and <a href="https://www.pierse.ie/cookies-policy">cookie policy</a>.
                          </CookieConsent>
                      </Route>
                  </Switch>
              </Router>
          </div>
      );
  }
}